import React from 'react'

export default function InputError({ name, error }) {
  return error[name] ? (
    <span
      style={{
        color: '#ff8a85',
        fontSize: '14px',
        paddingTop: '14px',
      }}
    >
      {error[name].message}
    </span>
  ) : null
}
